import { HttpResponse } from '@angular/common/http';

export class FileUtils {
  /**
   * Extracts the filename advertised in a response's Content-Disposition header.
   * Supports the RFC 5987 `filename*=UTF-8''...` form (percent-decoded) as well
   * as quoted and unquoted `filename=` forms.
   *
   * @param response - The HTTP response carrying the header
   * @returns The filename, or undefined when the header is absent or unreadable
   */
  public static extractFilenameFromResponse(response: HttpResponse<unknown>): string | undefined {
    const contentDisposition = response.headers.get('content-disposition');
    if (!contentDisposition) {
      return undefined;
    }
    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
    if (utf8Match?.[1]) {
      return decodeURIComponent(utf8Match[1]);
    }
    const fileMatch = /filename="?([^";]+)"?/i.exec(contentDisposition);
    return fileMatch?.[1];
  }
}
